import { DEFAULT_ERR_MSG } from '../../helpers/errorMsg'

export type RefereeSurveyErrorReason =
    | 'invalid-link'
    | 'survey-unavailable'
    | 'submission-failed'
    | 'network-error'
    | 'unknown'

export type RefereeSurveyErrorState = {
    title: string
    desc: string
}

export const isRefereeSurveyNetworkError = (error: unknown) => {
    if (!error || typeof error !== 'object') return false

    const firebaseError = error as { code?: unknown; message?: unknown }
    const code = typeof firebaseError.code === 'string' ? firebaseError.code : ''
    const message =
        typeof firebaseError.message === 'string'
            ? firebaseError.message.toLowerCase()
            : ''

    return (
        code.includes('network') ||
        code.includes('unavailable') ||
        message.includes('network') ||
        message.includes('offline') ||
        message.includes('timeout') ||
        message.includes('timed out')
    )
}

export const getRefereeSurveyErrorState = (
    reason: RefereeSurveyErrorReason = 'unknown'
): RefereeSurveyErrorState => {
    switch (reason) {
        case 'invalid-link':
            return {
                title: 'This survey link is no longer available',
                desc: 'The reference survey link may be invalid or expired. Please contact Spark Support so we can help.',
            }
        case 'submission-failed':
            return {
                title: "We couldn't save your response",
                desc: 'Please try again in a moment. If the issue continues, contact Spark Support.',
            }
        case 'network-error':
            return {
                title: "We couldn't reach the survey service",
                desc: 'Please check your connection and try again. If the issue continues, contact Spark Support.',
            }
        case 'survey-unavailable':
            return {
                title: "We're having trouble loading this survey",
                desc: 'Please try again shortly, or contact Spark Support if the issue continues.',
            }
        default:
            return {
                title: 'Something went wrong',
                desc: DEFAULT_ERR_MSG,
            }
    }
}
